import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["detail", "detailTitle", "detailContent", "ordersData"]

  connect() {
    this.ordersData = {}
    if (this.hasOrdersDataTarget) {
      try {
        const data = JSON.parse(this.ordersDataTarget.textContent)
        this.ordersData = data.orders_by_date || {}
      } catch (e) {
        console.error("Failed to parse orders data:", e)
      }
    }
    this.selectedDate = null
    this.selectedButton = null

    // 오늘 날짜 자동 선택
    this.selectToday()
  }

  selectToday() {
    const todayButton = this.element.querySelector('[data-calendar-today="true"]')
    if (todayButton) {
      todayButton.click()
    }
  }

  selectDate(event) {
    const button = event.currentTarget
    const date = event.params.date

    // 이전 선택 해제
    if (this.selectedButton) {
      this.selectedButton.classList.remove("selected")
    }

    // 새로운 선택
    this.selectedButton = button
    this.selectedDate = date
    button.classList.add("selected")

    // 상세 정보 표시
    this.showDetail(date)
  }

  showDetail(date) {
    const orders = this.ordersData[date] || []

    // 날짜 포맷팅
    const dateObj = new Date(date)
    const weekdays = ["일", "월", "화", "수", "목", "금", "토"]
    const formattedDate = `${dateObj.getFullYear()}년 ${dateObj.getMonth() + 1}월 ${dateObj.getDate()}일 (${weekdays[dateObj.getDay()]})`

    this.detailTitleTarget.textContent = formattedDate
    this.detailTarget.classList.remove("hidden")

    if (orders.length === 0) {
      this.detailContentTarget.innerHTML = `
        <div class="text-center py-8 text-gray-400">
          <svg class="w-12 h-12 mx-auto mb-3 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
          </svg>
          <p>출고 예정인 주문이 없습니다</p>
        </div>
      `
      return
    }

    const orderCards = orders.map(order => `
      <div class="flex items-center justify-between p-4 bg-gray-50 rounded-xl hover:bg-gray-100 transition-colors">
        <div class="flex items-center gap-4">
          <div class="w-10 h-10 rounded-full flex items-center justify-center ${order.fully_shipped ? 'bg-green-100' : 'bg-orange-100'}">
            ${order.fully_shipped
              ? '<svg class="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/></svg>'
              : '<svg class="w-5 h-5 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>'
            }
          </div>
          <div>
            <div class="flex items-center gap-2">
              <span class="font-semibold text-gray-900">${order.order_number}</span>
              <span class="toss-badge ${order.fully_shipped ? 'toss-badge-success' : 'toss-badge-warning'} toss-badge-sm">
                ${order.fully_shipped ? '출고완료' : '미출고'}
              </span>
            </div>
            <div class="text-sm text-gray-500 mt-0.5">
              ${order.delivery_time || ''} · ${order.customer_name} · ${order.partner_name} · ${order.order_type_label}
            </div>
          </div>
        </div>
        <div class="flex items-center gap-2">
          <a href="${order.show_path}" class="btn btn-ghost btn-sm">상세</a>
          ${!order.fully_shipped ? `<a href="${order.pending_path}" class="btn btn-primary btn-sm">출고</a>` : ''}
        </div>
      </div>
    `).join("")

    this.detailContentTarget.innerHTML = `
      <div class="space-y-3">
        ${orderCards}
      </div>
      <div class="mt-4 pt-4 border-t border-gray-100 flex justify-end">
        <a href="${orders[0]?.pending_path}" class="btn btn-ghost btn-sm gap-1">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 10h16M4 14h16M4 18h16"/>
          </svg>
          리스트에서 보기
        </a>
      </div>
    `
  }
}
